class Extranet.Settings

  @_COOKIE_NAME = 'usedRatePlan'
  @GROUPON_RATE: 'grouponRate'
  @NET_RATE: 'netRate'

  @getRateType: ->
    return @GROUPON_RATE if Extranet?.RolePermissions?.is_admin_user
    Cookie.get(@_COOKIE_NAME) or @GROUPON_RATE
